import { Component } from "react";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import queryString from "query-string";
import Dropdown from "react-bootstrap/Dropdown";
import "@mobiscroll/react/dist/css/mobiscroll.min.css";
import { Datepicker, Page } from "@mobiscroll/react";
import Moment from "moment";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Menu } from "antd";
import { Spinner } from "react-bootstrap";
import { getCurrentLocation, reverseGeocode } from "../../../services/GeolocationService";
import FilterCheckboxRow from "./FilterCheckboxRow";

const queryParams = queryString.parse(location.search);

class GlobalFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: {},
      city_name: props.queryParams
        ? props.queryParams.city_name
        : props.queryParams
          ? props.queryParams.city
          : "",
      selectedDate: "",
      adultCount: 0,
      childCount: 0,
      bedroomcount: 0,
      bathCount: 0,
      infantCount: 0,
      petsCount: 0,
      petsAllowed: false,
      bedroom: "",
      location: queryParams.city ? queryParams.city : [],
      location_name: [],
      guestValue: "",
      bedbathValue: "",
      bathroom: "",
      page: props.page,
      add: props.queryParams && props.queryParams.furnished
        ? props.queryParams.furnished
        : "",
      property_slug: props.match ? props.match.params.propertySlug : "",
      move_in_date: props.queryParams.checkin
        ? props.queryParams.checkin
        : Moment(new Date()).format("YYYY/MM/DD"),
      move_out_date: props.queryParams.checkout
        ? props.queryParams.checkout
        : "",
      adultCount: 0,
      childCount: 0,
      infantCount: 0,
      petsCount: 0,
      petsAllowed:
        props.queryParams.petsAllowed === "1" ||
        props.queryParams.petsAllowed === 1,
      queryString: "",
      queryStringltr: "",
      locationSelected: false,
      loaderSearch: false,
      latitude: queryParams.lat ? queryParams.lat : "",
      longitude: queryParams.lng ? queryParams.lng : "",
      locationName2: localStorage.getItem("locationName"),
    };
    this.incrementAdult = this.incrementAdult.bind(this);
    this.decrementAdult = this.decrementAdult.bind(this);
    this.incrementbath = this.incrementbath.bind(this);
    this.decrementbath = this.decrementbath.bind(this);
    this.incrementBed = this.incrementBed.bind(this);
    this.decrementBed = this.decrementBed.bind(this);
    this.incrementchild = this.incrementchild.bind(this);
    this.decrementchild = this.decrementchild.bind(this);
    this.incrementinfant = this.incrementinfant.bind(this);
    this.decrementinfant = this.decrementinfant.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.changeHandlerSelect = this.changeHandlerSelect.bind(this);
    this.guestDetail = this.guestDetail.bind(this);
    this.bedbathDetail = this.bedbathDetail.bind(this);
    this.Setclosebath = this.Setclosebath.bind(this);
    this.createQueryString();
    this.createQueryStringLtr();
    this.Setclose = this.Setclose.bind(this);
    this.handleChangelocation = this.handleChangelocation.bind(this);
    this.togglePetsAllowed = this.togglePetsAllowed.bind(this);
  }

  changeHandler = (event) => {
    let input = this.state.input;
    let value = event.target.value;
    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });
  };

  changeHandlerSelect = async (event) => {
    let input = this.state.input;
    input.add = event.target.value;
    await this.setState({ add: event.target.value, input: input });
    await this.createQueryString();
    await this.createQueryStringLtr();
  };

  componentDidMount = async () => {
    if (this.props.page === "str") {
      await this.setState({
        adultCount:
          this.props.queryParams.numberOfAdults != "" &&
            !isNaN(this.props.queryParams.numberOfAdults)
            ? parseInt(this.props.queryParams.numberOfAdults)
            : 0,
        childCount:
          this.props.queryParams.numberOfChildren != "" &&
            !isNaN(this.props.queryParams.numberOfChildren)
            ? parseInt(this.props.queryParams.numberOfChildren)
            : 0,
        infantCount:
          this.props.queryParams.numberOfInfants != "" &&
            !isNaN(this.props.queryParams.numberOfInfants)
            ? parseInt(this.props.queryParams.numberOfInfants)
            : 0,
        petsCount:
          this.props.queryParams.numberOfPets != "" &&
            !isNaN(this.props.queryParams.numberOfPets)
            ? parseInt(this.props.queryParams.numberOfPets)
            : 0,
        city_id:
          this.props.queryParams.city != "" &&
            !isNaN(this.props.queryParams.city)
            ? parseInt(this.props.queryParams.city)
            : 0,
        petsAllowed:
          this.props.queryParams.petsAllowed === "1" ||
          this.props.queryParams.petsAllowed === 1,
      });
      await this.guestDetail();
      await this.createQueryStringLtr();
      await this.createQueryString();
    } else {
      await this.setState({
        bedroomcount:
          this.props.queryParams.numberOfbed != "" &&
            !isNaN(this.props.queryParams.numberOfbed)
            ? parseInt(this.props.queryParams.numberOfbed)
            : 0,
        bathCount:
          this.props.queryParams.numberOfbathroom != "" &&
            !isNaN(this.props.queryParams.numberOfbathroom)
            ? parseInt(this.props.queryParams.numberOfbathroom)
            : 0,
        city_id:
          this.props.queryParams.city != "" &&
            !isNaN(this.props.queryParams.city)
            ? parseInt(this.props.queryParams.city)
            : 0,
      });
      await this.bedbathDetail();
      await this.createQueryStringLtr();
      await this.createQueryString();
    }
  };

  async setCurrentLocation() {
    try {
      const { latitude, longitude } = await getCurrentLocation();
      // const { city, state, countryCode } = await reverseGeocode(latitude, longitude);
      // const stateCode = this.props.getStateCodeByName(state, countryCode);

      this.setState({
        location: [],
        latitude,
        longitude,
        locationName2: 'Nearby',
        locationSelected: true,
        city_id: "",
        city_name: "",
      });

      localStorage.setItem("locationName", 'Nearby');
      this.createQueryString();
      this.createQueryStringLtr();
    } catch (error) {
      console.error(error.message);
    }
  }
  createQueryString = () => {
    var queryString = "";
    queryString = `?city_name=${this.state.city_name ? this.state.city_name : this.state.location_name
      }&city=${this.state.city_id ? this.state.city_id : this.state.location
      }&checkin=${this.state.selectedDate}&furnished=${this.state.add
      }&numberOfbed=${this.state.bedroomcount}&numberOfbathroom=${this.state.bathCount
      }&petsAllowed=${this.state.petsAllowed ? 1 : 0}&lat=${this.state.location > 0 ? "" : this.state.latitude}&lng=${this.state.location > 0 ? "" : this.state.longitude}`;
    this.setState({ queryString: queryString });
  };

  searchRedirect = (path) => {
    this.setState({ loaderSearch: true });
    if (this.state.locationSelected) {
      this.setState({ loaderSearch: true });
      window.location.href =
        "/" +
        path +
        (path === "floorplan-listing"
          ? this.state.queryString
          : this.state.queryStringltr);
    } else {
      var unit = document.getElementById("autocomplete-" + path);
      this.setState({ loaderSearch: false });
      if (unit) {
        unit.click();
      }
    }
  };

  createQueryStringLtr = () => {
    var queryStringltr = "";
    queryStringltr = `?city_name=${this.state.city_name ? this.state.city_name : this.state.location_name
      }&city=${this.state.city_id ? this.state.city_id : this.state.location
      }&checkin=${this.state.selectedDate}&checkout=${this.state.move_out_date ? this.state.move_out_date : ""
      }&furnished=${"Furnished"}&numberOfAdults=${this.state.adultCount
      }&numberOfChildren=${this.state.childCount}&numberOfInfants=${this.state.infantCount
      }&petsAllowed=${this.state.petsAllowed ? 1 : 0}&lat=${this.state.location > 0 ? "" : this.state.latitude}&lng=${this.state.location > 0 ? "" : this.state.longitude}`;
    this.setState({ queryStringltr: queryStringltr });
  };
  Setclose() {
    var unit = document.getElementById("dropdown-basic-bath");
    if (unit) {
      unit.click();
    }
  }
  bedbathDetail = () => {
    var message = "";
    message += this.state.bedroomcount > 1
      ? this.state.bedroomcount + " Bedrooms"
      : this.state.bedroomcount === 1
        ? this.state.bedroomcount + " Bedroom"
        : "";

    // Add comma if both bedroomcount > 0 and bathCount > 0
    if (this.state.bedroomcount > 0 && this.state.bathCount > 0) {
      message += ", ";
    }

    // Add bathroom count message
    message += this.state.bathCount > 1
      ? this.state.bathCount + " Bathrooms"
      : this.state.bathCount === 1
        ? this.state.bathCount + " Bathroom"
        : "";
    this.setState({ bedbathValue: message });
    // return message;
  };
  Setclosebath() {
    var unit = document.getElementById("dropdown-basic-bed");
    if (unit) {
      unit.click();
    }
  }
  async incrementbath() {
    await this.setState({ bathCount: this.state.bathCount + 1 });
    await this.createQueryString();
    await this.bedbathDetail();
  }

  async decrementbath() {
    if (this.state.bathCount === 0) {
      await this.setState({ bathCount: 0 });
    } else {
      await this.setState({ bathCount: this.state.bathCount - 1 });
    }
    await this.createQueryString();
    await this.bedbathDetail();
  }

  async incrementBed() {
    await this.setState({ bedroomcount: this.state.bedroomcount + 1 });
    await this.createQueryString();
    await this.bedbathDetail();
  }

  async decrementBed() {
    if (this.state.bedroomcount === 0) {
      await this.setState({ bedroomcount: 0 });
    } else {
      await this.setState({ bedroomcount: this.state.bedroomcount - 1 });
    }
    await this.createQueryString();
    await this.bedbathDetail();
  }

  async incrementAdult() {
    await this.setState({ adultCount: this.state.adultCount + 1 });
    await this.createQueryStringLtr();
    await this.guestDetail();
  }

  async decrementAdult() {
    if (this.state.adultCount === 0) {
      await this.setState({ adultCount: 0 });
    } else {
      await this.setState({ adultCount: this.state.adultCount - 1 });
    }
    await this.createQueryStringLtr();
    await this.guestDetail();
  }

  async incrementchild() {
    await this.setState({ childCount: this.state.childCount + 1 });
    await this.createQueryStringLtr();
    await this.guestDetail();
  }

  async decrementchild() {
    if (this.state.childCount === 0) {
      await this.setState({ childCount: 0 });
    } else {
      await this.setState({ childCount: this.state.childCount - 1 });
    }
    await this.createQueryStringLtr();
    await this.guestDetail();
  }

  async incrementinfant() {
    await this.setState({ infantCount: this.state.infantCount + 1 });
    await this.createQueryStringLtr();
    await this.guestDetail();
  }

  async decrementinfant() {
    if (this.state.infantCount === 0) {
      await this.setState({ infantCount: 0 });
    } else {
      await this.setState({ infantCount: this.state.infantCount - 1 });
    }
    await this.createQueryStringLtr();
    await this.guestDetail();
  }

  guestDetail = () => {
    let message = "";

    // Add adult count message
    if (this.state.adultCount > 0) {
        message += this.state.adultCount > 1
            ? this.state.adultCount + " Guests"
            : this.state.adultCount === 1
                ? this.state.adultCount + " Guest"
                : "";
        
        // Add comma if childCount or infantCount is greater than 0
        if (this.state.childCount > 0 || this.state.infantCount > 0) {
            message += ", ";
        }
    }

    // Add child count message (if adultCount is 0, a comma may have been added after child count)
    if (this.state.childCount > 0) {
        message += this.state.childCount > 1
            ? this.state.childCount + " Children"
            : this.state.childCount === 1
                ? this.state.childCount + " Child"
                : "";

        // Add comma if infantCount or petsCount is greater than 0
        if (this.state.infantCount > 0 || this.state.petsCount > 0) {
            message += ", ";
        }
    }

    // Add infant count message (only if childCount or petsCount is present)
    if (this.state.infantCount > 0) {
        message += this.state.infantCount > 1
            ? this.state.infantCount + " Infants"
            : this.state.infantCount === 1
                ? this.state.infantCount + " Infant"
                : "";

        // Add comma if petsCount is greater than 0
        if (this.state.petsCount > 0) {
            message += ", ";
        }
    }

    // Add pets count message
    if (this.state.petsCount > 0) {
        message += this.state.petsCount > 1
            ? this.state.petsCount + " Pets"
            : this.state.petsCount === 1
                ? this.state.petsCount + " Pet"
                : "";
    }

    if (this.state.petsAllowed) {
        message += message ? ", Pets allowed" : "Pets allowed";
    }

    this.setState({ guestValue: message });
  };

  togglePetsAllowed = async () => {
    await this.setState((prevState) => ({
      petsAllowed: !prevState.petsAllowed,
    }));
    await this.createQueryStringLtr();
    await this.createQueryString();
    await this.guestDetail();
  };

  changeDateHandlerNew = (date) => {
    this.props.changeDateHandlerNew(date);
    this.createQueryStringLtr();
    this.createQueryString();
  };

  handleChangelocation = async (event, value) => {
    let input = this.state.input;

    // Ensure you're selecting the entire city object, not just part of it
    input[event.label] = value ? value.value : ""; // Store the city_id (value)
    const location = value ? value.value : ""; // Store the city_id (value)

    // If a valid value is selected, set location_name accordingly
    const locationName = value ? value.label.split(",")[0] : ""; // Only the part before the comma
    const locationName2 = value ? value.label : ""; // Only the part before the comma

    await this.setState({
      city_id: location, // Store the full object (city object)
      location_name: locationName,
      city_name: locationName2,
      locationName2: locationName2,
      input: input,
      locationSelected: true,
      latitude: "",
      longitude: "",
    });
    this.props.handleChangelocation(event);
    await this.createQueryString();
    await this.createQueryStringLtr();
  };

  filterData = async () => {
    this.setState({ loaderSearch: true });
    if (this.props.page === "str") {
      let inputData2 = {
        property_seo_slug: this.props.propertySlug
          ? this.props.propertySlug
          : "",
        city_id: this.state.city_id ? this.state.city_id : "",
        Furnished:
          this.state.add === "All"
            ? []
            : this.state.add === "Unfurnished"
            ? ["Unfurnished"]
            : ["Fully Furnished"],
        Move_in_date: this.props.startDate
          ? Moment(new Date(this.props.startDate)).format("YYYY-MM-DD")
          : Moment(new Date()).format("YYYY-MM-DD"),
        Move_out_date: this.props.endDate
          ? Moment(new Date(this.props.endDate)).format("YYYY-MM-DD")
          : "",
        guestValue:
          this.state.adultCount +
          this.state.childCount +
          this.state.infantCount,
        petsAllowed: this.state.petsAllowed ? 1 : 0,
        lat: this.state.latitude,
        lng: this.state.longitude,
      };
      await this.props.filterData(inputData2);
    } else {
      let inputData2 = {
        property_seo_slug: this.props.propertySlug
          ? this.props.propertySlug
          : "",
        city_id: this.state.city_id ? this.state.city_id : "",
        Furnished:
          this.state.add === "All"
            ? []
            : this.state.add === "Unfurnished"
            ? ["Unfurnished"]
            : ["Fully Furnished"],
        Move_in_date:
          this.props.startDate !== ""
            ? Moment(this.props.startDate).format("YYYY-MM-DD")
            : Moment(new Date()).format("YYYY-MM-DD"),
        Bedroom: this.state.bedroomcount ? [this.state.bedroomcount] : [],
        Bathroom: this.state.bathCount ? [this.state.bathCount] : [],
        isquery: 1,
        lat: this.state.latitude,
        lng: this.state.longitude,
      };
      await this.props.filterData(inputData2);
    }
    this.setState({ loaderSearch: false });
  };

  render() {
    const inputPropsLtr = {
      className: "md-mobile-picker-input",
      placeholder: "Add date",
    };
    const inputProps = {
      className: "md-mobile-picker-input",
      placeholder: "Add dates",
    };
    return (
      <div className="mainfilter">
        <div className="container">
          <div className="filtersection">
            <Tabs
              defaultActiveKey={
                this.props.queryParams && this.props.queryParams.tab === "StayHere"
                  ? "stay-here"
                  : this.props.queryParams && this.props.queryParams.tab === "LiveHere"
                  ? "live-here"
                  : this.props.page === "ltr"
                  ? "live-here"
                  : "stay-here"
              }
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <Tab eventKey="live-here" title="Live here">
                <div className="tab-section">
                  <div className="search d-flex flex-column justify-content-start align-items-start">
                    <label>Where</label>
                    <Stack
                      direction="row"
                      spacing={2}
                      alignItems="center"
                    >
                      <Autocomplete
                        freeSolo
                        id="free-solo-2-demo"
                        name="location"
                        // disableClearable
                        disablePortal
                        value={this.state.locationName2}
                        onChange={(e, v) => {
                          this.handleChangelocation(e, v); // Pass the full city object to the handler
                        }}
                        options={this.props.locationArr || []} // Ensure options contain city objects with `label` and `value`
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            hiddenLabel
                            InputProps={{
                              ...params.InputProps,
                              type: "search",
                            }}
                            placeholder="Search locations"
                          />
                        )}
                      />
                      <img
                        src={global.OnKeyPressEvent.getS3ImageUrl("Location-Detect.svg")}
                        alt="Current Location"
                        title="Use Current Location"
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                        }}
                        onClick={() => { this.setCurrentLocation() }}
                      />

                    </Stack>
                  </div>
                  <div className="add d-flex flex-column justify-content-start align-items-start">
                    <label>Add</label>
                    <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        value={this.state.add ? this.state.add : "All"}
                        //disabled
                        name="add"
                        onChange={(event) => this.changeHandlerSelect(event)}
                      >
                        <MenuItem value="All">All</MenuItem>
                        <MenuItem value="Furnished">Furnished</MenuItem>
                        <MenuItem value="Unfurnished">Unfurnished</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="when d-flex flex-column justify-content-start align-items-start">
                    <label>When</label>
                    <Datepicker
                      controls={["calendar"]}
                      buttons={[
                        {
                          icon: "material-close",
                          handler: "cancel",
                        },
                      ]}
                      pages={1}
                      calendarType="month"
                      invalid={[]}
                      inputComponent="input"
                      inputProps={inputPropsLtr}
                      defaultValue={this.props.startDate}
                      onChange={(date) => this.changeDateHandlerNew(date)}
                      name="dateFour"
                      rangeSelectMode="wizard"
                      showRangeLabels={true}
                      touchUi={false}
                      theme="ios"
                      themeVariant="light"
                      headerText=""
                      max=""
                      responsive={{
                        xsmall: {
                          pages: 1,
                          touchUi: false,
                          calendarSize: "2",
                          cssClass: "single_pick_date",
                          calendarScroll: "horizontal",
                          refDate: Moment(new Date()).add(1, "year"),
                        },
                        medium: {
                          pages: 1,
                        },
                      }}
                    />
                  </div>
                  <div className="details d-flex flex-column justify-content-start align-items-start">
                    <label className="vs-hide-">Details</label>
                    <Dropdown autoClose={false}>
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic-bed"
                      >
                        <TextField
                          id="outlined-read-only-input"
                          InputProps={{
                            readOnly: true,
                          }}
                          className="inputBox"
                          value={this.state.bedbathValue}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          placeholder="Add bedrooms"
                        />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <div className="d-flex justify-content-between pd-15 pd-b-5">
                          <ul>
                            <li>
                              <li>
                                <b>
                                  {this.state.bedroomcount > 1
                                    ? "Bedrooms"
                                    : "Bedroom"}
                                </b>
                              </li>
                            </li>
                          </ul>
                          <div className="d-flex align-items-center countBtn">
                            <span>
                              <button
                                onClick={this.decrementBed}
                                // disabled={
                                //   this.state.bedroomcount === 1 ? true : false
                                // }
                              >
                                <img
                                  src={global.OnKeyPressEvent.getS3ImageUrl(
                                    "minus-guest.svg"
                                  )}
                                  alt="Decrement guest counter"
                                  title="Decrement guest counter"
                                />
                              </button>
                            </span>
                            <span>{this.state.bedroomcount}</span>
                            <span>
                              <button onClick={this.incrementBed}>
                                <img
                                  src={global.OnKeyPressEvent.getS3ImageUrl(
                                    "plus-guest.svg"
                                  )}
                                  alt="Increment guest counter"
                                  title="Increment guest counter"
                                />
                              </button>
                            </span>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between pd-15 pd-b-5">
                          <ul>
                            <li>
                              <li>
                                <b>
                                  {this.state.bathCount > 1
                                    ? "Bathrooms"
                                    : "Bathroom"}
                                </b>
                              </li>
                            </li>
                          </ul>
                          <div className="d-flex align-items-center countBtn">
                            <span>
                              <button onClick={this.decrementbath}>
                                <img
                                  src={global.OnKeyPressEvent.getS3ImageUrl(
                                    "minus-guest.svg"
                                  )}
                                  alt="Decrement guest counter"
                                  title="Decrement guest counter"
                                />
                              </button>
                            </span>
                            <span>{this.state.bathCount}</span>
                            <span>
                              <button onClick={this.incrementbath}>
                                <img
                                  src={global.OnKeyPressEvent.getS3ImageUrl(
                                    "plus-guest.svg"
                                  )}
                                  alt="Increment guest counter"
                                  title="Increment guest counter"
                                />
                              </button>
                            </span>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <button
                            className="done"
                            id="cnt-close"
                            onClick={this.Setclosebath}
                          >
                            Close
                          </button>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  {this.props.page === "ltr" ? (
                    <>
                      <div className="search-btn">
                        <button
                          className={
                            this.state.loaderSearch ? "search_loader" : ""
                          }
                        >
                          <img
                            alt="Live here search"
                            title="Live here search"
                            src={global.OnKeyPressEvent.getS3ImageUrl(
                              "search-icon.svg"
                            )}
                            onClick={() => this.filterData()}
                          />
                        </button>
                      </div>
                      <div className="mobilesearch-btn">
                        <button onClick={() => this.filterData()}>
                          {this.state.loaderSearch ? (
                            <>
                              <Spinner
                                as="span"
                                animation="grow"
                                role="status"
                                aria-hidden="true"
                                className="spinner_loader"
                              />
                              <Spinner
                                as="span"
                                animation="grow"
                                role="status"
                                aria-hidden="true"
                                className="spinner_loader"
                              />
                              <Spinner
                                as="span"
                                animation="grow"
                                role="status"
                                aria-hidden="true"
                                className="spinner_loader"
                              />
                            </>
                          ) : (
                            "Search"
                          )}
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="search-btn">
                        {this.state.property_slug ? (
                          <button>
                            <a
                              href={
                                global.themeUrl +
                                this.state.property_slug +
                                "/floorplan-listing" +
                                this.state.queryStringltr
                              }
                            >
                              <img
                                src={global.OnKeyPressEvent.getS3ImageUrl(
                                  "search-icon.svg"
                                )}
                                alt="Floor plan search"
                                title="Floor plan search"
                              />
                            </a>
                          </button>
                        ) : (
                          <button>
                            <a
                              href={
                                "/floorplan-listing" + this.state.queryStringltr
                              }
                            >
                              <img
                                src={global.OnKeyPressEvent.getS3ImageUrl(
                                  "search-icon.svg"
                                )}
                                alt="Floor plan search"
                                title="Floor plan search"
                              />
                            </a>
                          </button>
                        )}
                      </div>
                      <div className="mobilesearch-btn">
                        {this.state.property_slug ? (
                          <button>
                            <a
                              href={
                                global.themeUrl +
                                this.state.property_slug +
                                "/floorplan-listing" +
                                this.state.queryStringltr
                              }
                            >
                              search
                            </a>
                          </button>
                        ) : (
                          <button>
                            <a
                              href={
                                "/floorplan-listing" + this.state.queryStringltr
                              }
                            >
                              Search
                            </a>
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </Tab>
              <Tab eventKey="stay-here" title="Stay here">
                <div className="tab-section">
                  <div className="search d-flex flex-column justify-content-start align-items-start">
                    <label>Where</label>
                    <Stack
                      direction="row"
                      spacing={2}
                      alignItems="center"
                    >
                      <Autocomplete
                        freeSolo
                        id="free-solo-2-demo"
                        name="location"
                        // disableClearable
                        disablePortal
                        value={this.state.locationName2}
                        onChange={(e, v) => {
                          this.handleChangelocation(e, v); // Pass the full city object to the handler
                        }}
                        options={this.props.locationArr || []} // Ensure options contain city objects with `label` and `value`
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            hiddenLabel
                            InputProps={{
                              ...params.InputProps,
                              type: "search",
                            }}
                            placeholder="Search locations"
                          />
                        )}
                      />
                      <img
                        src={global.OnKeyPressEvent.getS3ImageUrl("Location-Detect.svg")}
                        alt="Current Location"
                        title="Use Current Location"
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                        }}
                        onClick={() => { this.setCurrentLocation() }}
                      />
                    </Stack>
                  </div>
                  <div className="add d-flex flex-column justify-content-start align-items-start">
                    <label>Add</label>
                    <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        value="Furnished"
                        // disabled
                        name="add"
                        onChange={(event) => this.changeHandlerSelect(event)}
                      >
                        <MenuItem value="Furnished">Furnished</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="when d-flex flex-column justify-content-start align-items-start">
                    <label>When</label>
                    <Datepicker
                      controls={["calendar"]}
                      buttons={[
                        {
                          // text: "X",
                          icon: "material-close",
                          handler: "cancel",
                        },
                      ]}
                      pages={2}
                      calendarType="month"
                      invalid={[]}
                      select="range"
                      inputComponent="input"
                      inputProps={inputProps}
                      defaultValue={
                        this.props.startDate + " - " + this.props.endDate
                      }
                      onChange={(date) => this.changeDateHandlerNew(date)}
                      name="dateFour"
                      closeOnEsc={true}
                      cssClass="str_dual_calendar"
                      rangeSelectMode="wizard"
                      showRangeLabels={true}
                      touchUi={false}
                      theme="ios"
                      themeVariant="light"
                      headerText=""
                      max=""
                      rangeStartLabel="Check-in"
                      rangeEndLabel="Check-out"
                      responsive={{
                        xsmall: {
                          pages: 2,
                          touchUi: false,
                          calendarScroll: "horizontal",
                          calendarSize: "2",
                          refDate: Moment(new Date()).add(1, "year"),
                        },
                        medium: {
                          pages: 2,
                        },
                      }}
                    />
                  </div>
                  <div className="details d-flex flex-column justify-content-start align-items-start">
                    <label>Details</label>
                    <Dropdown autoClose={false}>
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic-bath"
                      >
                        <TextField
                          id="outlined-read-only-input"
                          label=""
                          InputProps={{
                            readOnly: true,
                          }}
                          className="inputBox"
                          placeholder="Add guests"
                          value={this.state.guestValue}
                          // sx={{ width: 220 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <div className="d-flex justify-content-between align-items-start  pd-15 pd-b-5">
                          <ul>
                            <li>
                              <b>
                                {this.state.adultCount > 1 ? "Adults" : "Adult"}
                              </b>
                              <i>Age 13+</i>
                            </li>
                          </ul>
                          <div className="d-flex align-items-center countBtn">
                            <span>
                              <button
                                onClick={this.decrementAdult}
                                // disabled={
                                //   this.state.adultCount === 1 ? true : false
                                // }
                              >
                                <img
                                  src={global.OnKeyPressEvent.getS3ImageUrl(
                                    "minus-guest.svg"
                                  )}
                                  alt="Decrement guest counter"
                                  title="Decrement guest counter"
                                />
                              </button>
                            </span>
                            <span>{this.state.adultCount}</span>
                            <span>
                              <button onClick={this.incrementAdult}>
                                <img
                                  src={global.OnKeyPressEvent.getS3ImageUrl(
                                    "plus-guest.svg"
                                  )}
                                  alt="Increment guest counter"
                                  title="Increment guest counter"
                                />
                              </button>
                            </span>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-start pd-15 pd-b-5">
                          <ul>
                            <li>
                              <b>
                                {this.state.childCount > 1
                                  ? "Children"
                                  : "Child"}
                              </b>
                              <i>Ages 2–12</i>
                            </li>
                          </ul>
                          <div className="d-flex align-items-center countBtn">
                            <span>
                              <button onClick={this.decrementchild}>
                                <img
                                  src={global.OnKeyPressEvent.getS3ImageUrl(
                                    "minus-guest.svg"
                                  )}
                                  alt="Decrement guest counter"
                                  title="Decrement guest counter"
                                />
                              </button>
                            </span>
                            <span>{this.state.childCount}</span>
                            <span>
                              <button onClick={this.incrementchild}>
                                <img
                                  src={global.OnKeyPressEvent.getS3ImageUrl(
                                    "plus-guest.svg"
                                  )}
                                  alt="Increment guest counter"
                                  title="Increment guest counter"
                                />
                              </button>
                            </span>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-start pd-15 pd-b-5">
                          <ul>
                            <li>
                              <b>
                                {this.state.infantCount > 1
                                  ? "Infants"
                                  : "Infant"}
                              </b>
                              <i>Under 2</i>
                            </li>
                          </ul>
                          <div className="d-flex align-items-center countBtn">
                            <span>
                              <button onClick={this.decrementinfant}>
                                <img
                                  src={global.OnKeyPressEvent.getS3ImageUrl(
                                    "minus-guest.svg"
                                  )}
                                  alt="Decrement guest counter"
                                  title="Decrement guest counter"
                                />
                              </button>
                            </span>
                            <span>{this.state.infantCount}</span>

                            <span>
                              <button onClick={this.incrementinfant}>
                                <img
                                  src={global.OnKeyPressEvent.getS3ImageUrl(
                                    "plus-guest.svg"
                                  )}
                                  alt="Increment guest counter"
                                  title="Increment guest counter"
                                />
                              </button>
                            </span>
                          </div>
                        </div>
                        <FilterCheckboxRow
                          id="global-filter-pets-allowed"
                          label="Pets Allowed"
                          description="Only show pet-friendly stays"
                          checked={this.state.petsAllowed}
                          onChange={this.togglePetsAllowed}
                        />

                        <div className="d-flex justify-content-end">
                          <button
                            className="done"
                            id="cnt-close"
                            onClick={this.Setclose}
                          >
                            Close
                          </button>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  {this.props.page === "str" ? (
                    <>
                      <div className="search-btn">
                        <button
                          className={
                            this.state.loaderSearch ? "search_loader" : ""
                          }
                        >
                          <img
                            alt="Stay here search"
                            title="Stay here search"
                            src={global.OnKeyPressEvent.getS3ImageUrl(
                              "search-icon.svg"
                            )}
                            onClick={() => this.filterData()}
                          />
                        </button>
                      </div>
                      <div className="mobilesearch-btn">
                        <button onClick={() => this.filterData()}>
                          {this.state.loaderSearch ? (
                            <>
                              <Spinner
                                as="span"
                                animation="grow"
                                role="status"
                                aria-hidden="true"
                                className="spinner_loader"
                              />
                              <Spinner
                                as="span"
                                animation="grow"
                                role="status"
                                aria-hidden="true"
                                className="spinner_loader"
                              />
                              <Spinner
                                as="span"
                                animation="grow"
                                role="status"
                                aria-hidden="true"
                                className="spinner_loader"
                              />
                            </>
                          ) : (
                            "Search"
                          )}
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="search-btn">
                        {this.state.property_slug ? (
                          <button>
                            <a
                              href={
                                global.themeUrl +
                                this.state.property_slug +
                                "/str-listing" +
                                this.state.queryStringltr
                              }
                            >
                              <img
                                alt="Stay here search"
                                title="Stay here search"
                                src={global.OnKeyPressEvent.getS3ImageUrl(
                                  "search-icon.svg"
                                )}
                              />
                            </a>
                          </button>
                        ) : (
                          <button>
                            <a
                              href={"/str-listing" + this.state.queryStringltr}
                            >
                              <img
                                alt="Stay here search"
                                title="Stay here search"
                                src={global.OnKeyPressEvent.getS3ImageUrl(
                                  "search-icon.svg"
                                )}
                              />
                            </a>
                          </button>
                        )}
                      </div>
                      <div className="mobilesearch-btn">
                        {this.state.property_slug ? (
                          <button>
                            <a
                              href={
                                global.themeUrl +
                                this.state.property_slug +
                                "/str-listing" +
                                this.state.queryStringltr
                              }
                            >
                              Search
                            </a>
                          </button>
                        ) : (
                          <button>
                            <a
                              href={"/str-listing" + this.state.queryStringltr}
                            >
                              Search
                            </a>
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div >
    );
  }
}

// export default TripsTable;
export default GlobalFilter;
